import { ILeadRepository } from '../../infrastructure/repositories'

export class CheckDocumentUseCase {
  constructor(private leadRepository: ILeadRepository) {}

  async execute(document: string, currentLeadDocument?: string): Promise<{
    exists: boolean
    documentType?: 'cpf' | 'cnpj'
    leadName?: string
    leadId?: string
  }> {
    if (!document) {
      return { exists: false }
    }

    // Remove formatação para comparação
    const cleanDocument = document.replace(/\D/g, '')

    // Verifica se é um documento válido (CPF tem 11 dígitos, CNPJ tem 14)
    if (cleanDocument.length !== 11 && cleanDocument.length !== 14) {
      return { exists: false }
    }

    // Se estamos editando um lead existente e o documento é o mesmo, não precisa verificar
    if (currentLeadDocument && currentLeadDocument.replace(/\D/g, '') === cleanDocument) {
      return { exists: false }
    }

    try {
      const result = await this.leadRepository.checkDocumentExists(document)
      if (result.exists && result.lead) {
        const documentType = cleanDocument.length === 11 ? 'cpf' : 'cnpj'
        return {
          exists: true,
          documentType,
          leadName: result.lead.name || '',
          leadId: result.lead.id,
        }
      }
      return { exists: false }
    } catch (error) {
      console.error('Erro ao verificar documento:', error)
      return { exists: false }
    }
  }
}